import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {CardMedia, Grid, Typography} from '@mui/material';

import {ReactComponent as EmpionLogo} from '../../../assets/empion_logo.svg';
import {CultureAnalysisPdfContext} from '../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';
import {orangeColors, empionOrangeGradient} from '../../../layouts/theme/designSystem';
import {greenColors} from '../../../layouts/theme/designSystem';
import {transformDate} from '../../../utils/dateUtils/dateFormattingUtils';
import {formatImageUrl} from '../../../utils/formatImageUrl';

export const CoverPage = () => {
  const {t, ready} = useTranslation('pdfDomain');

  const {data, loading, language} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }
  const locale = language === 'de' ? 'de-DE' : 'en-US';

  const surveyDate = transformDate(data.companySurvey.endedAt ?? '', 'longMonthYear', locale);

  return (
    <>
      <Grid
        container
        alignItems={'center'}
        direction={'column'}
        pt={15}
        sx={{background: empionOrangeGradient.base}}
        minHeight={'100vh'}
      >
        <Grid item container alignContent={'center'} direction={'column'} justifyContent={'center'}>
          <Grid
            item
            container
            width={'600px'}
            bgcolor={'white'}
            borderRadius={'16px'}
            borderColor={orangeColors[3]}
            justifyContent={'center'}
            alignSelf={'center'}
            mb={5}
            p={2}
          >
            <CardMedia
              component={'img'}
              src={formatImageUrl(data.company.logoUrl) || ''}
              sx={{height: '160px', width: '214px', objectFit: 'contain'}}
            />
          </Grid>
          <Grid item container justifyContent={'center'}>
            <CardMedia
              component={'img'}
              src={data.cultureInformation.cultureType.imageUrl}
              sx={{height: '160px', width: '214px', objectFit: 'contain'}}
            />
          </Grid>
        </Grid>
        <Typography fontWeight={'400'} fontSize={'34px'} lineHeight={'82px'} color={greenColors[700]}>
          {t('coverPage.subtitleOne')}
        </Typography>
        <Typography variant='h1' fontSize={'58px'} textAlign={'center'} lineHeight={'58px'} color={greenColors[700]}>
          {ready ? <div dangerouslySetInnerHTML={{__html: t('coverPage.title') || ''}} /> : null}
        </Typography>
        <Typography fontWeight={'400'} fontSize={'24px'} lineHeight={'82px'} color={greenColors[700]}>
          {t('coverPage.subtitleTwo', {date: surveyDate})}
        </Typography>
        <Grid item container justifyContent={'center'} mb={2} mt={5}>
          <EmpionLogo fill={greenColors[700]} height='24px' width='120px' />
        </Grid>
      </Grid>
    </>
  );
};
